<template>
  <div>
    <qx-search-box class="searchBox" ref="searchBox" :searchBoxData="searchBoxData" title="筛选" @sub="sub" @reset="reset"
                   permpisionsQuery></qx-search-box>
    <TableBox ref="tableBox"></TableBox>
  </div>
</template>

<script>
import TableBox from './tableBox';
import {getAccessoryNameList, getAccessoryModelList} from 'api/service';

export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        accessoryNameOptions: [], // 配件名称
        accessoryModelOptions: [], // 型号
        form: [
          { // 配件名称
            label: '配件名称',
            value: 'accessoryName',
            type: 'select',
            default: -1,
            onChange: (accessoryName) => {
              this.chooseAccessoryName(accessoryName);
            },
            filterable: true,
            placeholder: '请选择配件名称',
          },
          { // 型号
            label: '型号',
            value: 'accessoryModel',
            type: 'select',
            default: -1,
            filterable: true,
            placeholder: '请选择型号',
          },
        ],
      },
    };
  },
  watch: {
    '$route.path': function (val) {
      if (val === '/manage/service/inventoryManagement/inventoryList') {
        this.getEnum('noFirst');
      }
    },
  },
  methods: {
    reset () {
      this.searchBoxData.accessoryModelOptions = [
        {
          label: '全部',
          value: -1,
        },
      ];
    },
    async getEnum (val) {
      const accessoryNameList = await getAccessoryNameList({
        accessoryName: '',
      });
      this.searchBoxData.accessoryNameOptions = [
        {
          label: '全部',
          value: -1,
        },
        ...accessoryNameList,
      ];
      if (!val) {
        await this.chooseAccessoryName();
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 配件名称
      let accessoryName = this.searchBoxData.accessoryNameOptions.find((item) => item.value === +this.$refs.searchBox.getVal('accessoryName'));
      searchBoxData.accessoryName = this.$refs.searchBox.getVal('accessoryName') === -1 ? '' : accessoryName.label;
      // 配件型号
      let accessoryModel = this.searchBoxData.accessoryModelOptions.find((item) => item.value === +this.$refs.searchBox.getVal('accessoryModel'));
      searchBoxData.accessoryModel = this.$refs.searchBox.getVal('accessoryModel') === -1 ? '' : accessoryModel.label;
      this.$refs.tableBox.saveSearchBoxData({...searchBoxData});
    },

    /**
     * @param {String} accessoryName 搜索栏 配件名称数据
     * @returns {void}
     * @description 搜索栏筛选 配件名称输入后联动调取查找配件型号
     * */
    async chooseAccessoryName (accessoryName) {
      if (accessoryName) {
        let resultData = this.searchBoxData.accessoryNameOptions.find((item) => item.value === accessoryName);
        const accessoryModelList = await getAccessoryModelList({
          accessoryName: resultData.label,
        });
        this.searchBoxData.accessoryModelOptions = [
          {
            label: '全部',
            value: -1,
          },
          ...accessoryModelList,
        ];
      } else {
        this.searchBoxData.accessoryModelOptions = [
          {
            label: '全部',
            value: -1,
          },
        ];
      }
    },
  },
  async created () {
    this.getEnum();
  },
};
</script>
